module.exports = __webpack_public_path__ + "assets/img/bg-a4cb3a37.jpg";